<template>
    <div>
        <div align="right">
            <v-btn min-width="25%" @click="getCompanies()">Actualizar</v-btn>
        </div>
        <v-data-table
            :items="companies"
            :headers="headers"
            :loading="loading_table"
            >
            <template v-for="header in headers" v-slot:[`item.${header.value}`]="{ item }">
              <span>
                <v-switch
                    v-if="header.value == 'stop_accounting_auto'"
                    v-model="item.stop_accounting_auto"
                    block
                    outlined
                    hide-details
                    :loading="isLoading(item.id)"
                    @click="update_accounting_auto(item.id, item.stop_accounting_auto)"
                >
                </v-switch>
                <p v-else>{{ item[header.value] }}</p>
              </span>
            </template>
        </v-data-table>
    </div>
</template>

<script>

import { query_dispatcher, sync_command_dispatcher } from '@/api/client';
import { ChangeAccountingAuto } from '@/modules/company/application/changeAccoutingAuto';
import { GetCompaniesByUserId } from '@/modules/company/application/getCompanies';

export default {
    name:'Debug',
    props: {
        user_data: {
            type:Object,
            required:true,   
        },
    },
    data() {
        return {
            companies:[],
            headers: [
                {
                    text: 'ID',
                    sortable: false,
                    value:'id'
                },
                {
                    text: 'Nombre',
                    sortable: false,
                    value: 'name'
                },
                {
                    text: '¿Contabilización parada?',
                    sortable: false,
                    value: 'stop_accounting_auto'
                },
                {
                    text: 'Fecha de última modificación',
                    sortable: false,
                    value: 'last_update_stop_accounting_auto'
                }, 
            ],
            loading_table: false,
            loadingStates: new Map(),
        }
    },
    methods: {
        async getCompanies(){
            await new GetCompaniesByUserId(query_dispatcher, this).run(this.user_data.id)
        },
        isLoading(itemId) {
            return this.loadingStates.get(`${itemId}`) || false;
        },
        change_loading_status(id, value){
            this.loadingStates.set(`${id}`, value);
        },
        async update_accounting_auto(id, value){
            await new ChangeAccountingAuto(sync_command_dispatcher, query_dispatcher, this).run(this.user_data.id, id, value)
        },
    },
    async mounted() {
        await this.getCompanies()
    },
}
</script>

<style scoped>

    .v-input--selection-controls {
        margin-top: 0px;
        padding-top: 0px;
    }

</style>